import { Page } from './page';
import { SurveyLink } from './survey-link';

export class Survey {

  id: number;
  name: string;
  description: string;
  name_pretty: string;
  description_pretty: string;
  key: string;
  group: string;
  created: string;
  activated: string;
  deactivated: string;
  deleted: string;
  state: string;
  language: string; // master language
  languages: string; // translation languages
  options: any;
  metadata: any;
  owner: string; // url of the survey user

  // fixme: needed?
  private pages: any;
  private links: any;

  private _languages: string[]; // translation languages
  getTranslationLanguages(): string[] {
    return this._languages;
  }

  setTranslationLanguages(languages: string[]) {
    this._languages = languages;
  }

  public get_languages() {
    let language_country_map = {
      'sv': 'SE',
      'en': 'GB',
      'ru': 'RU',
      'nb': 'NO',
      'de': 'DE',
    };
    let languages = [];
    languages.push({'lang': this.language, 'country': language_country_map[this.language].toUpperCase()});
    for (let lang of this._languages) {
      console.log('lang', lang);
      languages.push({'lang': lang, 'country': language_country_map[lang].toUpperCase()});
    }
    return languages;
  }

  private _pages: Page[];
  _pages_map: {};

  getPages(): Page[] {
    return this._pages;
  }

  setPages(pages: Page[]) {
    this._pages = pages;
  }

  private _links: SurveyLink[];

  getSurveyLinks(): SurveyLink[] {
    return this._links;
  }

  setSurveyLinks(links: SurveyLink[]) {
    this._links = links;
  }

  insertPage(page: Page, index: number) { // page.order contains the order
    this._pages.splice(index, 0, page);
    for (var i: number = index + 1; i < this._pages.length; i++) {
      this._pages[i].order++;
    }
  }

  deletePage(page: Page) {
    let new_pages = [];
    let page_was_deleted: boolean = false;
    for (let apage of this.getPages()) {
      if (apage.id == page.id)
        page_was_deleted = true;
      else
        new_pages.push(apage);
      if (page_was_deleted)
        apage.order -= 1;
    }
    this._pages = new_pages;
    if (this._pages.length == 0) {
      this.setCurrentPage(null);
    }
  }

  isOnlyOnePage(): boolean {
    return this.getPages().length == 1;
  }

  movePage(page: Page, new_order: number): void {
    let current_order = page.order;

    if (new_order == null)
      new_order = this._pages.length;

    if (new_order == this._pages.length) {
      page.order = this._pages.length - 1;
      this._pages.splice(current_order, 1);
      for (var i = current_order; i < this._pages.length; i++)
        this._pages[i].order = i;
      this._pages.push(page);
    } else if (current_order == new_order) {
    } else {
      this._pages.splice(current_order, 1);
      this._pages.splice(new_order, 0, page);
      if (new_order < current_order) {
        for (var i = new_order; i < this._pages.length; i++)
          this._pages[i].order = i;
      } else {
        for (var i = current_order; i < this._pages.length; i++)
          this._pages[i].order = i;
      }
    }
  }

  private _current_page: Page = null;

  setCurrentPage(page: Page) {
    this._current_page = page;
  }

  getCurrentPage(): Page {
    return this._current_page;
  }

  getPageById(page_id: number): Page {
    return this._pages_map[page_id];
  }

  toJSON(): Object {
    // create an instance of the Survey class
    let survey = Object.create(Survey.prototype);
    // copy all the fields to the json object
    survey.name = this.name;
    survey.description = this.description;
    survey.key = this.key;
    survey.language = this.language;
    if (this.languages) {
      survey.languages = this._languages.join(',');
    }
    survey.owner = this.owner;
    return survey;
  }

  static fromJSON(survey_json: any): Survey {

    // create an instance of the Question class
    let survey = Object.create(Survey.prototype);
    // copy all the fields from the json object
    let obj = Object.assign(survey, survey_json, {
      // convert fields that need converting
      //created: new Date(survey_json.created),
    });

    if (survey_json.languages) {
      survey._languages = survey_json.languages.split(',');
    } else {
      survey._languages = [];
    }

    let links_json = survey.links;
    let _links: SurveyLink[] = [];

    for (let link_json of links_json) {
      let link = SurveyLink.fromJSON(link_json);
      _links.push(link);
    }
    survey.setSurveyLinks(_links);
    delete survey.links;

    let pages_json = survey.pages;
    let _pages: Page[] = [];
    survey._pages_map = {};

    for (let page_json of pages_json) {
      let page = Page.fromJSON(page_json);
      _pages.push(page);
      survey._pages_map[page.id] = page;
    }
    survey.setPages(_pages);
    delete survey.pages;
    // set parents on child objects
    for (let link of survey.getSurveyLinks()) {
      link.setSurvey(survey);
    }
    for (let page of survey.getPages()) {
      page.setSurvey(survey);
      for (let question of page.getQuestions()) {
        question.setSurvey(survey);
        question.setPage(page);
        for (let choice of question.getChoices()) {
          choice.setSurvey(survey);
          choice.setPage(page);
          choice.setQuestion(question);
        }
      }
      for (let navigation_rule of page.getNavigationRules()) {
        navigation_rule.setSurvey(survey);
        navigation_rule.setPage(page);
      }
    }
    // set the first page as the current page
    if (survey.getPages().length > 0) {
      survey.setCurrentPage(survey.getPages()[0]);
    }

    return survey;
  }

}

